import HeadingSkeleton from "./HeadingSkeleton";

const MyAccountSkeleton = () => {
    return (
        <>
            <div className="hdnSec acctBtnHldr">
                <HeadingSkeleton width="180px" height="34px" />
                {/* <div className="myAcctBtns" style={{ float: "right" }}>
                    <div className="skeleton" style={{ width: 130, height: 42, borderRadius: 8, marginRight: 10, display: "inline-block" }} />
                    <div className="skeleton" style={{ width: 170, height: 42, borderRadius: 8, marginRight: 10, display: "inline-block" }} />
                </div> */}
            </div>

            <div className="myaccountDiv">
                <ul>
                    {Array.from({ length: 10 }).map((_, index) => (
                        <li key={`my-account-skeleton-${index}`}>
                            <div className="skeleton" style={{ width: 140, height: 14, marginBottom: 8 }} />
                            <div className="skeleton" style={{ width: `${55 + (index % 3) * 10}%`, height: 18 }} />
                        </li>
                    ))}
                </ul>
            </div>

            {/* <div className="hdnSec">
                <div className="skeleton" style={{ width: 220, height: 42, borderRadius: 4 }} />
            </div> */}
        </>
    );
};

export default MyAccountSkeleton;
